import React from "react";

import { OrderDetailsModal } from "../molecules/order-details-modal/OrderDetailsModal";
import { useParams } from "react-router-dom";

export const OrderPreview: React.FC = () => {
  const { id } = useParams();
  if (!id) return null;
  return <OrderDetailsModal id={id} disabled/>;
};
